import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Search } from "../../shared/Search";
import { Button } from "primereact/button";

interface Iprops {
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

interface ICompanyList {
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    contact_Person_ID?: number,
    ID?: number
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ICompanyList>, loading: boolean });
    const [selectCompany1, setSelectCompany1] = useState<ICompanyList | null>(null);
    const [selectCompany2, setSelectCompany2] = useState<any>([]);
    const [filters, setFilters] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const dt1 = useRef<any>(null);
    const dt2 = useRef<any>(null);

    const header1 = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Select Correct Company Name</h5>
        </div>
    );
    const header2 = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Select Wrong Company Name</h5>
        </div>
    );

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Data_Correction", "GET", null, `filter=${filters}`, props.toast);
        if (response) {
            const data: Array<ICompanyList> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center p-2">
                <h5 className="m-0">Company Name</h5>
                <span className="block mt-2 md:mt-0 p-input-icon-left ml-2">
                    {props.permissions.is_View && <Search setSearch={setFilters} />}
                </span>
            </div>
        );
    };

    const updateToDB = async () => {
        setLoading(true);

        let body = {
            correct: selectCompany1 !== null ? selectCompany1?.vendor_Company_ID : 0,
            wrong: selectCompany2.length > 0 ? selectCompany2.map((e: { vendor_Company_ID: number; }) => e.vendor_Company_ID) : [],
        };

        if (body.correct !== null && body.correct !== 0 && body.wrong.length > 0) {
            const response = await Fetch("Data_Correction", "PUT", body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', detail: "Company Updated Successfully", life: 3000 });
                setSelectCompany1(null);
                setSelectCompany2([]);
            }
        } else {
            if (body.wrong.length === 0) {
                props.toast.current.show({ severity: 'error', detail: "Please Select atleat 1 from Wrong Company", life: 3000 });
            } else props.toast.current.show({ severity: 'error', detail: "Please Select from Correct Company", life: 3000 });
        }

        if (filters) {
            if (filters.length >= 2) {
                loadTableData();
            }
        }

        setLoading(false);
    }

    useEffect(() => {
        if (filters) {
            if (filters.length >= 2) {
                loadTableData();
            }
        }
    }, [filters]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            <div className="flex flex-wrap">
                {props.permissions.is_View && filters && filters?.length >= 2 && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", width: "50%" }}
                    ref={dt1} size="small" stripedRows scrollable scrollHeight="75vh"
                    value={tableData.tableData}
                    emptyMessage="No Date found."
                    resizableColumns showGridlines columnResizeMode="expand"
                    header={header1}
                    loading={tableData.loading}
                    selectionMode={'checkbox'}
                    selection={selectCompany1}
                    onSelectionChange={(e) => {
                        const value = e.value as ICompanyList;
                        console.log(value);
                        setSelectCompany1(value);
                    }}
                >
                    {props.permissions.is_Update && <Column selectionMode="single" style={{ maxWidth: "3rem" }} />}
                    <Column field="vendor_Company_ID" header="Company ID" />
                    <Column field="vendor_Company_Name" header="Company Name" />
                </DataTable>}
                {props.permissions.is_View && filters && filters?.length >= 2 && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", width: "50%" }}
                    ref={dt2} size="small" stripedRows scrollable scrollHeight="75vh"
                    value={tableData.tableData}
                    emptyMessage="No Data found."
                    resizableColumns showGridlines columnResizeMode="expand"
                    header={header2}
                    loading={tableData.loading}
                    selectionMode={'checkbox'}
                    selection={selectCompany2}
                    onSelectionChange={(e) => {
                        const value = e.value as ICompanyList[];
                        setSelectCompany2(value);
                    }}
                >
                    {props.permissions.is_Update && <Column selectionMode="multiple" style={{ maxWidth: "3rem" }} />}
                    <Column field="vendor_Company_ID" header="Company ID" />
                    <Column field="vendor_Company_Name" header="Company Name" />
                </DataTable>}
            </div>
            {props.permissions.is_View && props.permissions.is_Update && <div className="flex col-12 md:col-12 align-items-center">
                <Button className=" col-12 md:col-6 h-2rem" loading={loading} label="UPDATE" onClick={updateToDB}></Button>
                <Button className="ml-1 col-12 md:col-6 p-button-outlined h-2rem" label="CLEAR" onClick={() => { setSelectCompany1(null); setSelectCompany2([]); }} type="button"></Button>
            </div>}
        </>
    );
}